/******************************************************************************************

     _                      _
    (_) _ __   ____  _ _   (_) _ __  __ _
    | |( '_ '\/ ,__)( '_'\ | |( '__)/'_' )
    | || | ) )\__, \| (_) )| || |  ( (_| |
    (_)(_) (_)(____/|  __/ (_)(_)   \__,_)
                    | |
                    (_)

    Inspira Digital Alterations - General Script
    =============================================
    

******************************************************************************************/

console.log('%cinspira digital', 'font-size:28px;font-weight:bold;color:#009ee2;text-shadow:0 1px 0 #ccc,0 2px 0 #c9c9c9,0 3px 0 #bbb,0 4px 0 #b9b9b9,0 5px 0 #aaa,0 6px 1px rgba(0,0,0,.1),0 0 5px rgba(0,0,0,.1),0 1px 3px rgba(0,0,0,.3),0 3px 5px rgba(0,0,0,.2),0 5px 10px rgba(0,0,0,.25),0 10px 10px rgba(0,0,0,.2),0 10px 10px rgba(0,0,0,.15);');
console.log('%cmaking sense of the web since 2008','font-size:12.3px;color:#aaa;padding-left: 1.9px;');

/* =======================================================================
  Most of the code in this script is sorted into basic
  class-like objects. The main inspira "class" is called
  using it's _init() function ... this then calls it's
  "sub classes" one by one. (Basically a self made class system ... ish)
======================================================================= */

// inspira class //
if(typeof inspira === 'undefined'){
  var inspira = {};
}

inspira = {

  timezone: 'Europe/Copenhagen',

  /**
  *@info used as the constructor of the class
  *@param void
  *@returns void
  */
  _init: function(){
    // set store default timezone
    moment.tz.setDefault(inspira.timezone);

    this.utilities._init();

    this.product._init();

    this.collection._init();

    this.membership._init();
  }
}



// utilities class extends inspira
inspira.utilities = {

  _init: function(){
    this.onChangeQuickCart();
  },

  getTotalQuickCart: function($this){
    var productPrice = $this.find('.price').data('price');
    var productAmount = $this.find('input.quantity').val();
    $this.find('.total-price').html(Shopify.formatMoney(productPrice * productAmount, window.shop.moneyFormat))
  },

  onChangeQuickCart: function(){
    var self = this;
    $('.quick-shop').find('input.quantity').change(function() {
        self.getTotalQuickCart($(this).closest($('.quick-shop')));
    });
    $('.quick-shop').find('.qty-minus').click(function() {
       self.getTotalQuickCart($(this).closest($('.quick-shop')));
    })
    $('.quick-shop').find('.qty-plus').click(function() {
        self.getTotalQuickCart($(this).closest($('.quick-shop')));
    })
  
  }

}

  inspira.membership = {

  _init: function(){
    this.scrollToForm();
    this.getImageCaptions();
  },

  scrollToForm: function(){
    $(".img-wrapper .button").click(function() {
        $('html, body').animate({
            scrollTop: $(".exclusive").offset().top - 68
        }, 750);
    });
  },

  getImageCaptions: function(){
    $('.memberships .rte img').each(function(){
      var caption = $(this).attr( "alt" );
      var captionHTML = '<p class="caption">' + caption + '</span>';
      $(this).parent('p').after(captionHTML);
    })
  }

}

// product class extends inspira
inspira.product = {


  _init: function(){
    this.refreshProductTimers();
  },

  /**
  *@info used to grab the date of the current product
  *@param key | product key seperating it from others on the page.
  *@return void
  */
  getProductDateByKey: function($key){
    if(typeof $key != 'string'){
      return $key.data('publish-date')
    }else{
      return $($key).data('publish-date');
    }
  },

  /**
  *@info show a call to action depending on its publication date
  *@param key | product key to search DOM with.
  *@return days_diff | the amount of days since the product was published.
  */
  getProductDateCTA: function(key){
    var publishDate,currentDate,convertedPublishDate,convertedCurrentDate,timeDiff,days_diff;
    
    publishDate = moment(this.getProductDateByKey(key));
    currentDate = moment();

    convertedPublishDate = publishDate.tz(inspira.timezone).unix();
    convertedCurrentDate = currentDate.tz(inspira.timezone).unix();
    timeDiff = convertedCurrentDate - convertedPublishDate;

    days_diff = Math.floor(timeDiff/86400);

    return days_diff;
  },

  getHoursTillMidnight: function(){
    var endOfTheDay, UnixTillMidnight, hoursTillMidnight, minutesTillMidnight, secondsTillMidnight,outputString, displayTime, suffix;

    endOfTheDay = moment().endOf('day').unix();
    unixTillMidnight = endOfTheDay - moment().unix();

    if(unixTillMidnight > 0){
      hoursTillMidnight = Math.floor(unixTillMidnight/3600);
      minutesTillMidnight = Math.floor((unixTillMidnight % 3600)/60)
      secondsTillMidnight = unixTillMidnight%60;



      if(hoursTillMidnight > 1){
        displayTime = hoursTillMidnight + " hours ";
      }else if(hoursTillMidnight == 1){
        displayTime = hoursTillMidnight + " hour ";
      }else{
        displayTime = '';
      }

      if(minutesTillMidnight > 1){
        displayTime += minutesTillMidnight + " minutes ";
      }else if(minutesTillMidnight == 1){
        displayTime += minutesTillMidnight + " minute ";
      }else{
        displayTime += '';
      }

      if(secondsTillMidnight > 1){
        displayTime += secondsTillMidnight + " seconds";
      }else if(secondsTillMidnight == 1){
        displayTime += secondsTillMidnight + " second";
      }else{
        displayTime += '';
      }

    }

    if(displayTime){
      displayTime += ' left';
    }
    return displayTime;
  },

  setProductTimer: function(key = '#product-wrapper'){
    var displayClass;
    var timeTillMidNight = inspira.product.getHoursTillMidnight();


    $(key).each(function(index){
      displayClass = 'green';
      if(inspira.product.getProductDateCTA($(this)) > 3){
        displayClass = 'red';
      }
      $(this).find('.time-left').html('<span class="' + displayClass + '">' + timeTillMidNight + '</span>');

    })
  },

  refreshProductTimers: function(){
    setInterval(this.setProductTimer, 1000 ); 
  },

}


inspira.collection = {

  _init: function(){
    this.refreshProductTimers();
  },

  refreshProductTimers: function(){
    setInterval(this.getAllProductTimers, 1000 ); 
  },

  getAllProductTimers: function(){
    inspira.product.setProductTimer('.product-wrap');
  }
}

$(function() {
  inspira._init();
}); 